import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './LogoCarousel.module.scss'

const Row3: React.FC = () => {
  return (
    <>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo18.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo8.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo20.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo2.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo25.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo19.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo22.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo24.png' className={styles.image} alt=''
        />
      </div>
    </>
  )
}

export default Row3
